import styled from 'styled-components';

type FluidWrapper = {
  large: boolean;
  multiline: boolean;
};
export const Wrapper = styled.div<FluidWrapper>`
  max-width: ${props =>
    (props.large && '404px;') || (props.multiline && '100%;')};
`;
